import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from './components/ContactForm';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { categories } from '@/utils/articles';

const guides = [
  {
    icon: 'ri-information-line',
    title: '内容免责声明',
    text: '本站所有爆料与资讯均基于网络公开信息整理，部分为产品演示用模拟内容，不代表本站立场。请读者理性看待，自行核实，切勿据此作出任何决策。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户须知',
    text: '本站为纯资讯展示平台，不提供登录、支付、下载等服务。你可以自由浏览、收藏与分享内容，收藏数据仅保存在你的浏览器本地，不会上传。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '隐私与合规',
    text: '我们尊重个人隐私与合法权益。若你认为某条内容侵犯了你的权益，请通过下方留言或邮箱联系我们，我们将在核实后及时处理。',
  },
];

export default function AboutPage() {
  useDocumentTitle({
    title: '关于我们 - 91黑料网',
    description:
      '了解91黑料网的定位、内容范围与更新频率，获取联系方式与使用说明。我们致力于提供最新娱乐黑料、明星爆料与社会热点资讯。',
    keywords: '关于91黑料网,91黑料网介绍,联系方式,免责声明,黑料资讯平台',
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-[1280px] px-4 py-6 md:px-6">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <header className="mt-4 animate-fade-up overflow-hidden rounded-lg border border-background-200 bg-foreground-950 p-6 md:p-10">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-medium text-primary-300">
            <i className="ri-alarm-warning-fill"></i>
            About 91黑料网
          </span>
          <h1 className="mt-4 text-2xl font-black text-background-50 md:text-4xl">
            关于 91黑料网
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
            91黑料网是一个聚焦最新娱乐黑料、明星爆料及社会热点新闻的资讯聚合平台，面向关注娱乐圈内幕与社会热点的广大网民，
            用清晰的结构与持续的更新，帮你在碎片化时间里快速掌握正在发酵的话题。
          </p>
        </header>

        <section className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {categories.map((c) => (
            <div
              key={c.slug}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <h2 className="mt-3 text-base font-bold text-foreground-950">{c.name}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                {c.description}
              </p>
              <Link
                to={`/category/${c.slug}`}
                className="mt-3 inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700"
              >
                进入频道
                <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>
          ))}
        </section>

        <section className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <h2 className="flex items-center gap-2 text-xl font-black text-foreground-950">
                <i className="ri-building-2-line text-primary-500"></i>
                网站介绍
              </h2>
              <div className="mt-4 space-y-4 text-sm leading-loose text-foreground-700">
                <p>
                  <strong className="text-foreground-900">定位：</strong>
                  我们专注于「最新黑料资讯与热门爆料」，内容覆盖娱乐黑料、明星爆料与社会热点三大方向，为关注娱乐圈内幕与社会热点的用户提供一站式信息入口。
                </p>
                <p>
                  <strong className="text-foreground-900">内容范围：</strong>
                  包含综艺内幕、番位与资源之争、明星恋情与合约风波、私生饭与代拍乱象，以及食品安全、职场内幕、消费维权、城市公共事件等社会话题。
                </p>
                <p>
                  <strong className="text-foreground-900">更新频率：</strong>
                  全站每日 07:00 至 24:00 持续更新，热点事件会以滚动方式补充进展，确保你看到的内容始终紧跟节奏。
                </p>
              </div>

              <div className="mt-6 grid grid-cols-1 gap-4 border-t border-background-200 pt-6 sm:grid-cols-2">
                <div className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-600">
                    <i className="ri-mail-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">爆料邮箱</p>
                    <p className="mt-0.5 text-sm text-foreground-600">tip@91heiliao.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-600">
                    <i className="ri-customer-service-2-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">合作咨询</p>
                    <p className="mt-0.5 text-sm text-foreground-600">press@91heiliao.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {guides.map((g) => (
                <div
                  key={g.title}
                  className="rounded-lg border border-background-200 bg-secondary-50 p-5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-accent-600">
                    <i className={`${g.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950">{g.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{g.text}</p>
                </div>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-28">
              <ContactForm />
            </div>
          </aside>
        </section>
      </main>

      <Footer />
    </div>
  );
}